import { StatType } from "@/types";
import SimpleBar from "@/ui/simplebar";
import cn from "@/utils/class-names";



interface IndexProps {
    data: StatType[]
}

export default function OrderStats({ data }: IndexProps) {
    return (
        <SimpleBar>
            <div className="grid grid-flow-col gap-5">
                {data.map((item) => (
                    <OrderStat key={item.id} {...item} />
                ))}
            </div>
        </SimpleBar>
    );
}

export function OrderStat({ count, icon, label }: StatType) {
    return (
        <div
            className={cn(
                "grid w-72 grid-cols-[56px_1fr] items-start gap-4 rounded-lg border border-gray-300 px-6 py-6 3xl:w-auto",
            )}
            // style={{ borderColor: bgColor }}
        >
            <figure className="relative flex items-center justify-center rounded-full [&>svg]:h-12 [&>svg]:w-12">
                {icon}
            </figure>
            <div>
                <p className="text-2xl font-bold text-gray-900">{count}</p>
                <p className="mt-0.5 text-sm text-gray-500">{label}</p>
            </div>
        </div>
    );
}
